import { useState, useEffect } from 'react';

import { type Heading, getHeadingList } from './getHeadingList';
import TableOfContents, { type TableOfContentsProps } from './TableOfContents';

type TableOfContentsWrapperProps = Omit<TableOfContentsProps, 'headingList'> & {
  selector: string;
  links: Heading[];
};

const TableOfContentsWrapper: React.FunctionComponent<TableOfContentsWrapperProps> = ({ title, headingListAriaLabel, selector, links }) => {
  const [headingList, setHeadingList] = useState<Heading[]>();

  useEffect(() => {
    const clientSideHeadingList = getHeadingList(selector);

    const headingListWithElements = links.map(heading => ({
      ...heading,
      element: clientSideHeadingList.find(x => x.slug === heading.slug)?.element,
    }));

    // eslint-disable-next-line react-hooks/set-state-in-effect
    setHeadingList(headingListWithElements);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selector]);

  if (!headingList) {
    return null;
  }

  return <TableOfContents title={title} headingList={headingList} headingListAriaLabel={headingListAriaLabel} />;
};

export default TableOfContentsWrapper;
